@if (vm.loading) {
  <section class="full-width flex flex-col">
    <app-skeleton-loader class="dark full-width max-w-320 h-60 sm-h-32" />
    <app-skeleton-loader class="dark full-width max-w-280 h-52 sm-h-32 mt-16" />
    <app-skeleton-loader class="dark full-width max-w-348 h-48 sm-h-32 mt-16" />
  </section>
} @else {
  <h2 class="heading-4 max-w-348">Expert advice to keep your appliance running smoothly</h2>

  <p class="body mt-8 max-w-348">
    Explore our Smart-fix hub for quick fixes, <br />
    maintenance tips and expert advice
  </p>

  <app-button
    dataLabel="smart-fix-hub"
    class="flex full-width max-w-348 mt-24"
    [buttonOptions]="{
      variant: 'secondary',
      isLink: true,
      fill: true,
      url: vm.url,
    }"
  >
    Go to Smart-fix hub
    <i class="fa-light fa-arrow-right ml-8"></i>
  </app-button>
}
